import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmsService } from 'src/app/core/services/cms/cms.service';
import { CommonService } from 'src/app/core/services/common.service';
import { HyperLink } from 'src/app/core/constants/hyperlink';
import { DateAdapter } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

interface Document {
  id: number;
  companyNameOne: string;
  companyNameOne_EN: string;
  companyNameTwo: string;
  companyNameTwo_EN: string;
  businessRegistrationNumber: string;
  businessRegistrationNumber_EN: string;
  address: string;
  address_EN: string;
  hotline: string;
  hotline_EN: string;
  email: string;
  urlImage: string;
}

@Component({
  selector: 'app-landingpage-footer',
  templateUrl: './landingpage-footer.component.html',
  styleUrls: ['./landingpage-footer.component.scss']
})
export class LandingpageFooterComponent implements OnInit {
  listFoots: any[];
  companyInforFoots: Document;
  public avatarUrl?: string;
  public titleaAvatarUrl?: string;
  public hyperLinkVTT: string = '';
  isEnLanguage = true;
  language = localStorage.getItem('__language') || 'vi';
  languageSub: Subscription;

  constructor(
    private cmsService: CmsService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
  ) {
    this.listFoots = [];
    this.companyInforFoots = {
      id: null,
      companyNameOne: '',
      companyNameTwo_EN: '',
      companyNameTwo: '',
      companyNameOne_EN: '',
      businessRegistrationNumber: '',
      businessRegistrationNumber_EN: '',
      address: '',
      address_EN: '',
      hotline: '',
      hotline_EN: '',
      email: '',
      urlImage: ''
    }
    this.hyperLinkVTT = HyperLink.VIETTEL_TELECOM;
    this.languageSub = this.translate.onLangChange.subscribe(({ lang }) => {
      this.language = lang;
    });
  }

  ngOnInit() {
    this.listFooterCategory();
    this.companyInformationFooter();
  }

  listFooterCategory() {
    this.cmsService.listFooterCategory().subscribe(
      res => {
        if (res.data && res.data != null) {
          this.listFoots = res.data;
          // console.log("footer category: ", this.listFoots);
        }
      }
    );
  }

  companyInformationFooter() {
    this.cmsService.companyInfor().subscribe(
      res => {
        if (res.data && res.data != null) {
          this.companyInforFoots.id = res.data.id == null || res.data.id == undefined ? '' : res.data.id;
          this.companyInforFoots.address = res.data.address == null || res.data.address == undefined ? '' : res.data.address;
          this.companyInforFoots.address_EN = res.data.addressEN == null || res.data.addressEN == undefined ? '' : res.data.addressEN;
          this.companyInforFoots.businessRegistrationNumber = res.data.businessRegistrationNumber == null || res.data.businessRegistrationNumber == undefined ? '' : res.data.businessRegistrationNumber;
          this.companyInforFoots.businessRegistrationNumber_EN = res.data.businessRegistrationNumberEN == null || res.data.businessRegistrationNumberEN == undefined ? '' : res.data.businessRegistrationNumberEN;
          this.companyInforFoots.companyNameOne = res.data.companyNameOne == null || res.data.companyNameOne == undefined ? '' : res.data.companyNameOne;
          this.companyInforFoots.companyNameOne_EN = res.data.companyNameOneEN == null || res.data.companyNameOneEN == undefined ? '' : res.data.companyNameOneEN;
          this.companyInforFoots.companyNameTwo = res.data.companyNameTwo == null || res.data.companyNameTwo == undefined ? '' : res.data.companyNameTwo;
          this.companyInforFoots.companyNameTwo_EN = res.data.companyNameTwoEN == null || res.data.companyNameTwoEN == undefined ? '' : res.data.companyNameTwoEN;
          this.companyInforFoots.email = res.data.email == null || res.data.email == undefined ? '' : res.data.email;
          this.companyInforFoots.hotline = res.data.hotline == null || res.data.hotline == undefined ? '' : res.data.hotline;
          this.companyInforFoots.hotline_EN = res.data.hotlineEN == null || res.data.hotlineEN == undefined ? '' : res.data.hotlineEN;
          this.companyInforFoots.urlImage = res.data.urlImage == null || res.data.urlImage == undefined ? '' : res.data.urlImage;
          // console.log("res.data", res.data);
          // console.log("companyInforFoots", this.companyInforFoots);

          // console.log("this.companyInforFoots.urlImage: ", this.companyInforFoots.urlImage);
          // if (this.companyInforFoots.urlImage) {
          //   const imageDataBlob = this.commonService.b64toBlob(this.companyInforFoots.urlImage);
          //   const blobUrl = URL.createObjectURL(imageDataBlob);
          //   this.avatarUrl = blobUrl;
          // }

        }
      }
    );
  }

  /**
   * check English Language
   */
  get isCurrentEnglish() {
      return this.language === 'en';
  }

  get isCurrentVietnamese() {
    return this.language === 'vi';
  }

  getTextFooterOptions(options) {
    if (typeof options !== 'undefined' && options !== null) {
      const txt = options !== ''? (this.isCurrentVietnamese ? options.name || '' : options.name_en || '') : '';
      return txt || '';
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  hyperlink(link: any, target: any) {
    // target="1" Chuyển liên kết trong tab hiện tại
    // target="2" Mở tab mới
    // target="3">Mở cửa sổ mới
    switch (target) {
      case 1:
        location.href = link;
        break;
      case 2:
        window.open(link, '_blank');
        break;
      case 3:
        window.open(link, '_blank', 'width=' + screen.availWidth + ',height=' + screen.availHeight)
        break;
      default:
        location.href = link;
        break;
    }
  }
}
